import { Tooltip } from 'antd';
import { FolderOpenFilled } from '@ant-design/icons';
import dayjs from 'dayjs'

const Columns = (handleOpenChangeLog, filters) => {
  return [
     {
      title: "Nombre",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => (a.name || '').localeCompare(b.name || ''),
      onHeaderCell: () => ({ style: { backgroundColor: '#FDE2E2', color: '#B22222', fontWeight: 'bold' } }),
      showSorterTooltip: false,
      width: '20%',
    },
    {
      title: "Estado",
      dataIndex: "status",
      key: "status",
      render: (status) => status?.name || "N/A",
      sorter: (a, b) => a.status?.name?.localeCompare(b.status?.name),
       filters: filters.statuses.map(status => ({
        text: status.name,
        value: status.name
      })),
      onFilter: (value, record) => record.status?.name === value,
      onHeaderCell: () => ({
        style: {
          backgroundColor: '#FDE2E2',
          color: '#B22222',
          fontWeight: 'bold',
        },
      }),
      showSorterTooltip: false,
      width: '20%',
    },
    {
      title: "Responsable Área",
      dataIndex: "responsible_area",
      key: "responsible_area",
      render: (area) => area?.name || "N/A",
      sorter: (a, b) =>
        a.responsible_area?.name?.localeCompare(b.responsible_area?.name),
      filters: filters.responsibleAreas.map(area => ({
        text: area.name,
        value: area.id,
      })),
      onFilter: (value, record) => record.responsible_area?.id === value,
      onHeaderCell: () => ({
        style: {
          backgroundColor: '#FDE2E2',
          color: '#B22222',
          fontWeight: 'bold',
        },
      }),
      showSorterTooltip: false,
      width: '30%',
    },
    {
      title: "Condición",
      dataIndex: "condition",
      key: "condition",
      render: (condition) => condition || "N/A",
      sorter: (a, b) =>
        a.condition?.localeCompare(b.condition || '') || 0,
      filters: filters.conditions.map(condition => ({
        text: condition.name,
        value: condition.name,
      })),
      onFilter: (value, record) => record.condition === value,
      onHeaderCell: () => ({
        style: {
          backgroundColor: '#FDE2E2',
          color: '#B22222',
          fontWeight: 'bold',
        },
      }),
      showSorterTooltip: false,
      width: '25%',
    },
    {
      title: "Fecha Comprometida",
      dataIndex: "date_committed",
      key: "date_committed",
      sorter: (a, b) => {
        const dateA = a.date_committed ? new Date(a.date_committed).getTime() : 0;
        const dateB = b.date_committed ? new Date(b.date_committed).getTime() : 0;
        return dateA - dateB;
      },
      onHeaderCell: () => ({ style: { backgroundColor: '#FDE2E2', color: '#B22222', fontWeight: 'bold' } }),
      showSorterTooltip: false,
      width: '35%',
      render: (date_committed) =>
        date_committed
          ? dayjs(date_committed).format('DD/MM/YYYY')
          : 'No especificada'
    },
    {
      title: 'Activo',
      dataIndex: ['gap', 'dependency_control', 'dependency', 'asset', 'name'],
      key: 'asset',
      sorter: (a, b) =>
        a.gap?.dependency_control?.dependency?.asset?.name
          ?.localeCompare(b.gap?.dependency_control?.dependency?.asset?.name),
      filterSearch: true,
      filters: filters.assets.map(asset => ({
        text: asset.name,
        value: asset.name
      })),
      onFilter: (value, record) =>
        record.gap?.dependency_control?.dependency?.asset?.name === value,
      onHeaderCell: () => ({
      style: { backgroundColor: '#FDE2E2', color: '#B22222', fontWeight: 'bold' },
        className: 'custom-filter-icon'
      }),
      showSorterTooltip: false,
      width: '25%'
    },
    {
      title: 'Dependencia',
      dataIndex: ['gap', 'dependency_control', 'dependency', 'name'],
      key: 'dependency',
      sorter: (a, b) =>
        a.gap?.dependency_control?.dependency?.name
          ?.localeCompare(b.gap?.dependency_control?.dependency?.name),
      filterSearch: true,
      filters: filters.dependencies.map(dep => ({
        text: dep.name,
        value: dep.name
      })),
      onFilter: (value, record) =>
        record.gap?.dependency_control?.dependency?.name === value,
      onHeaderCell: () => ({
        style: { backgroundColor: '#FDE2E2', color: '#B22222', fontWeight: 'bold' },
        className: 'custom-filter-icon'
      }),
      showSorterTooltip: false,
      width: '30%'
    },
    {
      title: 'Control',
      dataIndex: ['gap', 'dependency_control', 'control', 'title'],
      key: 'control',
      sorter: (a, b) =>
        a.gap?.dependency_control?.control?.title
          ?.localeCompare(b.gap?.dependency_control?.control?.title),
      onHeaderCell: () => ({
        style: { backgroundColor: '#FDE2E2', color: '#B22222', fontWeight: 'bold' },
        className: 'custom-filter-icon'
      }),
      showSorterTooltip: false,
      ellipsis: true,
      render: (_, record) => {
        const title = record.gap?.dependency_control?.control?.title;
        if (!title) return <span style={{ color: '#999' }}>Sin título</span>;

        const truncated = title.length > 50 ? `${title.substring(0, 50)}...` : title;

        return title.length > 40 ? (
          <Tooltip title={title}>
            <span>{truncated}</span>
          </Tooltip>
        ) : (
          <span>{truncated}</span>
        );
      },
      width: '30%'
    },  
    {
      title: 'Tipo GAP',
      dataIndex: ['gap', 'type'],
      key: 'type',
      sorter: (a, b) => a.gap?.type?.localeCompare(b.gap?.type),
      filters: filters.types.map(type => ({
        text: type.name,
        value: type.name
      })),
      filteredValue: filters.filteredTypeValue,
      onFilter: (value, record) => {
        // Filtro normal
        return record.gap?.type === value;
      },
      onHeaderCell: () => ({
        style: { backgroundColor: '#FDE2E2', color: '#B22222', fontWeight: 'bold' },
        className: 'custom-filter-icon'
      }),
      showSorterTooltip: false,
      width: '20%'
    },
    {
      title: "Responsable GAP",
      dataIndex: ['gap', 'area', 'name'],
      key: "area",
      sorter: (a, b) =>
        a.gap?.area?.name?.localeCompare(b.gap?.area?.name),
      filters: filters.areas.map(area => ({
        text: area.name,
        value: area.name
      })),
      onFilter: (value, record) => record.gap?.area?.name === value,
      onHeaderCell: () => ({
        style: { backgroundColor: '#FDE2E2', color: '#B22222', fontWeight: 'bold' }
      }),
      showSorterTooltip: false,
      width: '30%',
    },
    {
      title: "Issue Asociado",
      dataIndex: "issue",
      key: "issue",
      render: (issue) => issue?.type || "N/A",
      sorter: (a, b) => a.issue?.type?.localeCompare(b.issue?.type),
      onHeaderCell: () => ({
        style: {
          backgroundColor: '#FDE2E2',
          color: '#B22222',
          fontWeight: 'bold',
        },
      }),
      showSorterTooltip: false,
      width: '30%',
    },
    {
      title: "Log",
      dataIndex: "log",
      key: "log",
      onHeaderCell: () => ({ 
        style: { backgroundColor: '#FDE2E2', color: '#B22222', fontWeight: 'bold' } 
      }),
      width: '5%',
      render: (_, record) => (
        <div style={{ textAlign: 'center' }}>
          <Tooltip title="Ver Log">
            <FolderOpenFilled 
              style={{ fontSize: 20, cursor: 'pointer', color: '#B22222' }}
              onClick={() => handleOpenChangeLog(record)}
            />
          </Tooltip>
        </div>
      ),
      width: '15%',
    }
  ];
};

export default Columns;